import { render } from "./MfNotes.vue?vue&type=template&id=4d8c7d54"
import script from "./MfNotes.vue?vue&type=script&lang=js"
export * from "./MfNotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__